import { matchPath } from 'react-router-dom';
import { ROUTE_ACCESS } from './routes';
import type { AccessRequirement } from './types';

const PUBLIC_PATH_PREFIXES = [
  '/session-timeout',
  '/logged-out',
  '/unauthorized',
] as const;

/** Paths handled outside ROUTE_ACCESS pattern matching. */
const PREFIX_ROUTE_ACCESS: ReadonlyArray<{ prefix: string; requirement: AccessRequirement | undefined }> = [
  { prefix: '/requests/new', requirement: ROUTE_ACCESS['/requests/new'] },
  { prefix: '/tasks/create-case-request', requirement: ROUTE_ACCESS['/tasks/create-case-request'] },
];

const SORTED_ROUTE_PATTERNS = Object.keys(ROUTE_ACCESS).sort((a, b) => b.length - a.length);

function normalizePathname(pathname: string): string {
  return pathname.split('?')[0].replace(/\/+$/, '') || '/';
}

export function shouldSkipPostAuthRouteValidation(pathname: string): boolean {
  const normalized = normalizePathname(pathname);
  if (normalized === '/') return true;
  return PUBLIC_PATH_PREFIXES.some((prefix) => normalized.startsWith(prefix));
}

/** Map the current URL to the same ROUTE_ACCESS policy used by route guards. */
export function resolveRouteAccessRequirement(pathname: string): AccessRequirement | undefined {
  const normalized = normalizePathname(pathname);

  for (const { prefix, requirement } of PREFIX_ROUTE_ACCESS) {
    if (normalized === prefix || normalized.startsWith(`${prefix}/`)) {
      return requirement;
    }
  }

  // View an existing case request (not the create wizard).
  if (/^\/requests\/[^/]+$/.test(normalized)) {
    return ROUTE_ACCESS['/requests'];
  }

  for (const pattern of SORTED_ROUTE_PATTERNS) {
    if (matchPath({ path: pattern, end: true }, normalized)) {
      return ROUTE_ACCESS[pattern];
    }
  }

  return undefined;
}
